import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-opportunities',
  templateUrl: './opportunities.component.html',
  styleUrls: ['./opportunities.component.css']
})
export class OpportunitiesComponent implements OnInit {

  opportunities: {
    illustration: string,
    title: string,
    about: string
  }[] = [
    {
      illustration: "assets/illustrations/security.svg",
      title: "Become a Dogo Trustee",
      about: "Dogo offers people a chance to improve the system by becoming trustee. Trustees have responsibility to verify professionals are not fraudulent and every task that happen under their eye is fair. Every trustee can charge an assurance fee from the user."
    },
    {
      illustration: "assets/illustrations/professional.png",
      title: "Become a Dogo Professional",
      about: "In Dogo anyone can become a professional without having to prove qualifications on paper. all one has to do is to verify their Aadhaar card and start earning straightforward."
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
